import { COOKIE_KEYS } from '@porterin/booking-flow/src/order-review/view/stores/OrderReviewStore';
import { AuthData } from '@porterin/booking-flow/src/order-review/view/types/CommonTypes';

export function getCookie(name: string): string | undefined {
  const cookies =
    typeof window !== 'undefined' ? document.cookie.split('; ') : [];
  for (let cookie of cookies) {
    const [key, value] = cookie.split('=');
    if (key === name) return decodeURIComponent(value);
  }
  return undefined;
}

export function deleteCookie(name: string) {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}

export const getTrackingCookieSafe = (): string => {
  return (
    getCookie(COOKIE_KEYS.VISITOR_ID) ||
    getCookie(COOKIE_KEYS.WEB_TRACKING_D) ||
    ''
  );
};

export const deleteTrackingCookie = () => {
  deleteCookie(COOKIE_KEYS.VISITOR_ID);
  deleteCookie(COOKIE_KEYS.WEB_TRACKING_D);
};

export const getAuthCookies = (): AuthData => {
  const authToken = getCookie(COOKIE_KEYS.AUTH_TOKEN) ?? '';
  const mobile = getCookie(COOKIE_KEYS.MOBILE) ?? '';
  const trackingId = getTrackingCookieSafe();

  return { authToken, mobile, trackingId };
};

export const deleteAuthCookies = () => {
  deleteCookie(COOKIE_KEYS.AUTH_TOKEN);
  deleteCookie(COOKIE_KEYS.MOBILE);
  deleteTrackingCookie();
};
export const setCookie = (cookie: string): void => {
  document.cookie = cookie;
};

export const setCookieWithExpiration = (
  key: string,
  value: string,
  days_to_expire: number,
): void => {
  const expiryTime = new Date(
    Date.now() + days_to_expire * 24 * 60 * 60 * 1000,
  ).toUTCString();
  document.cookie = `${key}=${value}; expires=${expiryTime}; path=/`;
};

export const getLocaleCookie = (): string => getCookie('NEXT_LOCALE') ?? '';
